import { useCallback, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { openDigitalTwin } from "./HomeDailyFocus";
import { fetchGroupSmartRoster } from "./funtionsBD/digipingSmartService";
import { currentAppLanguage } from "../utils/appLanguages";
import "./CoachProfilePanel.css";

/**
 * Coach profile SMART area — manage players' paths only.
 * There is no coach SMART twin path for now.
 */
export default function CoachProfilePanel() {
  const { t, i18n } = useTranslation();
  const lang = currentAppLanguage(i18n);
  const [groups, setGroups] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const roster = await fetchGroupSmartRoster({ lang }).catch(() => ({ groups: [], players: [] }));
      setGroups(Array.isArray(roster?.groups) ? roster.groups : []);
    } finally {
      setLoading(false);
    }
  }, [lang]);

  useEffect(() => {
    load();
  }, [load]);

  const openPlayerSmartPaths = () =>
    openDigitalTwin({
      home_role: "coach",
      tab: "people",
      seedVisible: false,
    });

  return (
    <div className="coach-profile-panel parent-profile-panel">
      <div
        className="coach-smart-board pst-card pst-rail-card"
        data-tour-id="profile-smart-tab"
      >
        <div className="coach-smart-board__head">
          <span className="coach-smart-board__kicker">{t("coachSmartTitle")}</span>
          <h3 className="coach-smart-board__title">{t("coachSmartManagePlayers")}</h3>
          <p className="coach-smart-board__lead">
            {t("coachSmartPlayersOnlyLead", {
              defaultValue:
                "Coaches manage players’ SMART paths. There is no coach SMART path for now.",
            })}
          </p>
        </div>

        <p className="coach-smart-letter__body coach-smart-letter__body--muted" data-tour-id="profile-smart-objectives">
          {loading
            ? t("loading")
            : groups.length
              ? t("coachSmartTapPlayerHint")
              : t("coachSmartNoGroupGoals")}
        </p>

        <div className="coach-smart-actions" data-tour-id="profile-smart-training">
          <button type="button" className="coach-smart-actions__primary" onClick={openPlayerSmartPaths}>
            {t("coachSmartManagePlayers")}
            {groups.length ? (
              <span className="coach-smart-actions__count">{groups.length}</span>
            ) : null}
          </button>
        </div>
      </div>
    </div>
  );
}
